module.exports = __webpack_public_path__ + "static/media/extinguishers_types.bcd256c7.jpg";